// @flow
import React, { useState, useCallback, useEffect } from 'react';
import AboutTemplate from 'components/about/AboutTemplate';
import withUser from 'lib/hoc/withUser';
import axios from 'lib/defaultClient';
import { compose } from 'redux';
import type { State } from 'store';
import { connect } from 'react-redux';

const AboutTemplateContainer = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [comments, setComments] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);

  const onChangeName = useCallback(e => {
    e.preventDefault();
    setName(e.target.value);
  }, []);

  const onChangeEmail = useCallback(e => {
    e.preventDefault();
    setEmail(e.target.value);
  }, []);

  const onChangeSubject = useCallback(e => {
    e.preventDefault();
    setSubject(e.target.value);
  }, []);

  const onChangeComments = useCallback(e => {
    e.preventDefault();
    setComments(e.target.value);
  }, []);

  const validateEmail = emailAddress => {
    // 골뱅이 뒤 이메일 도메인이 .뒤에 문자가 하나인 것도 걸러준다.
    const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

    setIsEmailValid(regExp.test(emailAddress));
  };

  const submitForm = e => {
    e.preventDefault();
    try {
      if (isEmailValid) {
        axios.post(`/internal/about`, { name, email, subject, comments });
        setName('');
        setComments('');
        setEmail('');
        setSubject('');
        setIsEmailValid(true);
        // eslint-disable-next-line
        alert('문의사항이 성공적으로 접수되었습니다!');
      } else {
        // eslint-disable-next-line
        alert('올바른 이메일 형식을 갖추어 입력해주세요.');
      }
    } catch (error) {
      // eslint-disable-next-line
      alert(
        '문의사항 접수 도중 에러가 발생하였습니다. help@cacheby.com으로 이메일 문의 주시거나 캐시바이 홈페이지에서 채팅으로 문의해주십시오.',
      );
      console.log(error);
    }
  };

  return (
    <AboutTemplate
      submitForm={submitForm}
      onChangeSubject={onChangeSubject}
      onChangeName={onChangeName}
      onChangeEmail={onChangeEmail}
      onChangeComments={onChangeComments}
      validateEmail={validateEmail}
      name={name}
      email={email}
      subject={subject}
      comments={comments}
      isEmailValid={isEmailValid}
    />
  );
};

export default compose(
  withUser,
  connect(
    ({ base }: State) => ({
      hidden: !base.landing,
    }),
    () => ({}),
  ),
)(AboutTemplateContainer);



// WEBPACK FOOTER //
// ./src/containers/about/AboutTemplateContainer.js